// import appLocaleData from 'react-intl/locale-data/zh';
import ptMessages from './lang/pt-BR.json';
import antdPt from 'antd/lib/locale-provider/pt_BR'; //antd语言包
// console.log(1111,appLocaleData)
let appLocale = {
  messages: {
    ...ptMessages,
  },
  antd: antdPt,
  locale: 'pt-BR',
};

export default appLocale;
